/* unplugin-vue-components disabled */import { render } from "./share-error.vue?vue&type=template&id=ef9ad4d6&scoped=true"
import script from "./share-error.vue?vue&type=script&lang=js"
export * from "./share-error.vue?vue&type=script&lang=js"

import "./share-error.vue?vue&type=style&index=0&id=ef9ad4d6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9ad4d6"],['__file',"src/pages/share-chat/share-error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef9ad4d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef9ad4d6', __exports__)) {
    api.reload('ef9ad4d6', __exports__)
  }
  
  module.hot.accept("./share-error.vue?vue&type=template&id=ef9ad4d6&scoped=true", () => {
    api.rerender('ef9ad4d6', render)
  })

}


export default __exports__